import { ReactElement, useCallback, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';

import { Icons } from 'components';
import { request } from 'app/utils';
import { useSchool } from 'features/school';
import { useProducts } from 'features/products';
import { useBreakpoints } from 'app/hooks';

const BadgeButtonIcon = styled(Icons)`
  width: 24px;
  color: white;
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
`;

const BadgeButton = styled('button')`
  min-width: 350px;
  height: 60px;
  position: relative;
  flex-grow: 1;
  padding: 0;
  border: 0;
  text-align: left;
  margin: 0;
  padding: 15px 20px 10px 20px;
  color: ${(props: any) =>
    props['data-schoolalias'] === 'b3' ? (props['data-status'] === 'interested' ? 'white' : props.theme.colors.dark_350) : 'white'};
  text-transform: uppercase;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  background: ${(props: any) => {
    if (props['data-status'] === 'interested') {
      return props.theme.colors.dark_150;
    }

    return props.theme.colors.primary_400;
  }};
  cursor: ${(props: any) => {
    if (props['data-status'] === 'interested') {
      return 'default';
    }

    return 'pointer';
  }};

  &:hover {
    background: ${(props: any) => {
      if (props['data-status'] === 'interested') {
        return props.theme.colors.dark_150;
      }

      return props.theme.colors.primary_200;
    }};

    ${BadgeButtonIcon} {
      color: ${(props: any) =>
        props['data-schoolalias'] === 'b3' ? (props['data-status'] === 'interested' ? 'white' : props.theme.colors.dark_350) : 'white'};
    }
  }
`;

interface EventInteressedButtonProps {
  label: string;
  labelMobile?: string;
  bordered?: boolean;
}

const EventInteressedButton = ({ label, labelMobile, bordered = false }: EventInteressedButtonProps): ReactElement => {
  const [status, setStatus] = useState<'idle' | 'loading' | 'interested'>('idle');

  const { productDetails } = useProducts();

  const { apiGatewayUrl, schoolAlias } = useSchool();

  const bkp = useBreakpoints();

  const endLabel = useMemo(() => {
    if (bkp === 'mobile' && labelMobile) {
      return labelMobile;
    }

    return label;
  }, [bkp, label, labelMobile]);

  const fetch = useCallback(() => {
    if (status === 'idle') {
      setStatus('loading');

      request({
        url: `/api/v1/School/Products/interest/${productDetails?.product?.slug}`,
        method: 'post',
        baseURL: apiGatewayUrl,
      })
        .then(() => {
          setStatus('interested');
        })
        .catch(() => {
          setStatus('idle');
        });
    }
  }, [productDetails, status]);

  useEffect(() => {
    if (productDetails?.hasInterest) {
      setStatus('interested');
    }
  }, [productDetails]);

  return (
    <>
      <BadgeButton
        style={{
          borderTopLeftRadius: bordered ? 4 : 0,
          borderTopRightRadius: bordered ? 4 : 0,
          borderBottomLeftRadius: 4,
          borderBottomRightRadius: 4,
        }}
        data-status={status}
        data-schoolalias={schoolAlias}
        onClick={fetch}
      >
        {status === 'interested' ? 'Interesse registrado' : endLabel}
        {status === 'loading' && <BadgeButtonIcon icon="loading" spin={1} />}
        {status === 'interested' && <BadgeButtonIcon icon="check" />}
        {status !== 'interested' && status !== 'loading' && <BadgeButtonIcon icon="star" />}
      </BadgeButton>
    </>
  );
};

export default EventInteressedButton;
